import { MenuItem } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { PageData } from '../../../../../interfaces/interfaces';
import { CTAButtonComponentInterface } from '../../../../../interfaces/pagebuilder';
import VySelect from '../../../../common/VySelect';

const CTAPageSelect = ({
  component,
  languageKey,
  pages,
  onChange,
}: {
  component: CTAButtonComponentInterface;
  languageKey?: string;
  pages: PageData[];
  onChange: (c: CTAButtonComponentInterface) => void;
}) => {
  const { t } = useTranslation();

  return (
    <VySelect
      fullWidth
      displayEmpty
      onChange={(e) => {
        const value = e.target.value;
        if (value) {
          const _page = pages.find((p) => p._id === value);
          if (!_page) return;
        }

        const _component = { ...component };
        if (languageKey) _component.languageUrls = { ..._component.languageUrls, [languageKey]: value as string };
        else _component.eventpage = value as string;
        onChange(_component);
      }}
      defaultValue={(languageKey ? component?.languageUrls?.[languageKey] : undefined) ?? component.eventpage ?? undefined}>
      <MenuItem value={undefined}>{t('pagebuilder:none')}</MenuItem>
      {pages
        .filter((p) => p._id !== component.page)
        .map((p) => (
          <MenuItem value={p._id}>{p.name}</MenuItem>
        ))}
    </VySelect>
  );
};
export default CTAPageSelect;
